var ctrl = function($scope) {
  $scope.resultsPerPage = $scope.pagination.perPage;

  var setupResultsOptions = function(){
    if ($scope.pagination && $scope.pagination.resultsOptions) {
      $scope.resultsOptions = [];
      _.each($scope.pagination.resultsOptions, function(option) {
        $scope.resultsOptions.push({k: option, v: option + ' results'})
      });
    } else {
      $scope.resultsOptions = [{k: 25, v: '25 results'},{k: 50, v: '50 results'},{k: 100, v: '100 results'}];
    }
  };

  setupResultsOptions();

  $scope.newNumberOfResults = function() {
    $scope.$emit('updateResultsPerPage', $scope.resultsPerPage);
  };
};

ctrl.$inject = ['$scope'];

tiz.controller('PaginationResultsPerPageCtrl', ctrl);

var directive = function() {
  return {
    controller: 'PaginationResultsPerPageCtrl',
    templateUrl: require('../../templates/pagination/results_per_page.html'),
    scope: {
      pagination: '='
    }
  };
};

tiz.directive('paginationResultsPerPage', directive);